import * as types from "../constants/actionTypes";
import initialState from "./initialState";

export const dealsReducer = (state = initialState.deals, action) => {
  switch (action.type) {
    case types.GET_DEALS_SUCCESS:
      return action.payload;

    case types.GET_DEALS_FAIL:
      return initialState.deals;

    default:
      return state;
  }
};

export const dealDetailsReducer = (state = initialState.deal, action) => {
  switch (action.type) {
    case types.GET_DEAL_DETAILS_SUCCESS:
      return action.payload;

    case types.GET_DEAL_DETAILS_FAIL:
      return initialState.deal;

    default:
      return state;
  }
};

export const dealSearchResultsReducer = (
  state = initialState.dealSearchResults,
  action
) => {
  switch (action.type) {
    case types.GET_DEAL_SEARCH_SUCCESS:
      return action.payload;

    case types.GET_DEAL_SEARCH_FAIL:
      return initialState.dealSearchResults;

    case types.DEAL_RATE_SELECTED: {
      const roomType = action.payload && action.payload.roomId;
      const updatedDeals =
        action.payload &&
        action.payload.dealSearchResults.map(deals => {
          const nextDeals = deals.map(deal => {
            if (deal && deal.roomType == roomType) {
              return {
                ...deal,
                availability: deal.availability - 1,
                rate: {
                  ...deal.rate,
                  availability: deal.rate.availability - 1
                }
              };
            } else return deal;
          });
          return nextDeals;
        });
      return updatedDeals;
    }

    case types.DEAL_RATE_UNSELECTED: {
      const roomType = action.payload && action.payload.roomId;
      const updatedDeals =
        action.payload &&
        action.payload.dealSearchResults.map(deals => {
          const nextDeals = deals.map(deal => {
            if (deal && deal.roomType == roomType) {
              return {
                ...deal,
                availableRooms: deal.availableRooms - 1,
                rate: {
                  ...deal.rate,
                  availability: deal.rate.availability - 1
                }
              };
            } else return deal;
          });
          return nextDeals;
        });
      return updatedDeals;
    }

    case types.GET_DEALS_SUCCESS: {
      return [];
    }

    case types.GET_DEAL_SEARCH_RESET:
      return initialState.dealSearchResults;

    default:
      return state;
  }
};

export const setDealMode = (state = initialState.isDealMode, action) => {
  switch (action.type) {
    case types.GET_ROOM_RESULTS_DEALS_REQUEST:
    case types.SET_SEARCH_DATA:
      return true;
    case types.RESET_ROOM_RESULTS_DEALS_REQUEST:
      return false;
    default:
      return state;
  }
};

export const hasDealResultsReducer = (
  state = initialState.hasDealResults,
  action
) => {
  switch (action.type) {
    case types.GET_DEAL_DETAILS_SUCCESS:
    case types.GET_DEALS_SUCCESS:
      return true;
    case types.GET_DEAL_DETAILS_FAIL:
    case types.GET_DEALS_FAIL:
      return false;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/dealsReducer.js